import React, { useMemo } from 'react';
import { useWorldActions } from 'components/World/hooks/useWorldActions';
import './index.scss';
import CloseIcon from 'assets/icons/CloseIcon';

import { SCENES_MAP } from '../../consts/building';

function sortArrayByAlphabet(arr) {
  return [...arr].sort((a, b) => {
    const groupA = (a.tourGroupName || '').toLowerCase();
    const groupB = (b.tourGroupName || '').toLowerCase();
    if (groupA < groupB) return -1;
    if (groupA > groupB) return 1;
    const titleA = (a.title || '').toLowerCase();
    const titleB = (b.title || '').toLowerCase();
    if (titleA < titleB) return -1;
    if (titleA > titleB) return 1;
    return 0;
  });
}

const EtownGallary = ({ items = [], onClose, onCloseMenu = () => { } }) => {
  const { selectSceneById } = useWorldActions();

  const sortedItems = sortArrayByAlphabet(items);

  const groupedItems = useMemo(() => {
    const groups = {};
    sortedItems.forEach((item) => {
      const groupName = item.tourGroupName || 'Other';
      if (!groups[groupName]) {
        groups[groupName] = [];
      }
      groups[groupName].push(item);
    });
    return groups;
  }, [sortedItems]);

  return (
    <div className="dp-gallery-container-wrapper">
      <div className="dpdoc-grid dp-gallery-container">
        <button className="dp-gallery-back-button" onClick={onClose}>
          <CloseIcon color="white" />
        </button>
        <div className="dpdoc-logo">
          <img src="/assets/images/logo/etown_logo.png" alt="logo" />
        </div>
        <div className='amenities-title'><span>Amenities</span></div>

        {Object.entries(groupedItems).map(([groupName, groupItems]) => (
          <div key={groupName} className="dpdoc-group-container">
            <div className="dpdoc-group-title">
              <span>{groupName}</span>
            </div>
            <div className="dpdoc-group-items">
              {groupItems.map((img, index) => {

                const overrideConfig = SCENES_MAP[img.id];


                const finalImageSrc = (overrideConfig && overrideConfig.preview)
                  ? overrideConfig.preview
                  : (img.coverImage || img.thumbUrl || img.url);

                return (
                  <div
                    key={`${groupName}-${index}`}
                    className={`dpdoc-card`}
                    onClick={() => {
                      selectSceneById('welcome', img.id);
                      onClose();
                      onCloseMenu();
                    }}
                  >
                    <img
                      src={finalImageSrc}
                      alt={img.title || 'gallery'}
                      loading="lazy"
                      decoding="async"
                    />

                    <div className="dpdoc-card-title">
                      <span>{img.title}</span>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default EtownGallary;